import React, { Suspense, lazy, useContext, useEffect } from 'react';
import { withRouter, useHistory, useLocation } from 'react-router-dom';

import FallbackSpinner from 'components/FallbackSpinner';

import AuthContext from 'contexts/AuthContext';
import { SidebarProvider } from 'contexts/SidebarContext';

const AuthRoutes = lazy(() => import('./AuthRoutes'));
const AppRoutes = lazy(() => import('./AppRoutes'));

const Routes: React.FC = () => {
  const history = useHistory();
  const location = useLocation();

  const { authenticated, validating } = useContext(AuthContext);

  useEffect(() => {
    window.scrollTo({ top: 0 });

    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }, [location.pathname]);

  useEffect(() => {
    const authOnlyPaths = ['/login', '/forgot', '/password', '/2fa'];

    if (authenticated && authOnlyPaths.includes(location.pathname)) {
      history.replace('/');
    }
  }, [authenticated, history, location.pathname]);

  if (validating) {
    return <FallbackSpinner />;
  }

  return (
    <Suspense fallback={<FallbackSpinner />}>
      <SidebarProvider>
        {authenticated ? <AppRoutes /> : <AuthRoutes />}
      </SidebarProvider>
    </Suspense>
  );
};

export default withRouter(Routes);
